/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Guide_LabelInputs */

const en_gc_editor_guide_label = /** @type {(inputs: Gc_Editor_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New to GridCraft?`)
};

const zh_gc_editor_guide_label = /** @type {(inputs: Gc_Editor_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初次使用 GridCraft？`)
};

/**
* | output |
* | --- |
* | "New to GridCraft?" |
*
* @param {Gc_Editor_Guide_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_guide_label = /** @type {((inputs?: Gc_Editor_Guide_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Guide_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_guide_label(inputs)
	return zh_gc_editor_guide_label(inputs)
});
export { gc_editor_guide_label as "gc.editor.guide_label" }